import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { gameActions } from "../../actions/gameActions";
import store from "../../store";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}
  componentWillReceiveProps(nextProps) {
    this.setState({
      disabled: nextProps.game.counter >= 4 ? true : false
    });
  }
  _add = () => {
    if (this.props.game && this.props.game.counter > 3) {
      return false;
    }
    store.dispatch(gameActions.addTime());
  };

  _toggle = ()=>{
    if (this.props.game.state === "RUN" || this.props.game.state === "PAUSE"){
        store.dispatch(gameActions.changeStatus());
    }
  }

  _startGame() {
    store.dispatch(gameActions.start());
  }

  render() {
    return (
      <header>
        <div id="hearer-container" className="row">
          <a className="col-lg-4 col-md-4 colsm-4 col-xs-4 button resume" onClick={this._toggle}>
            {this.props.game.state == "RUN" ? "PAUSE" : "RESUME"}
          </a>
          <a
            className="col-lg-4 col-md-4 colsm-4 col-xs-4 button go"
            onClick={this._startGame}
          >
            go!
          </a>
          <a
            className={
              this.state.disabled
                ? "col-lg-4 col-md-4 colsm-4 col-xs-4 button pluse-off"
                : "col-lg-4 col-md-4 colsm-4 col-xs-4 button pluse"
            }
            onClick={this._add}
            disabled={this.state.disabled}
          >
            {this.props.game.counter > 0 ? (
              <div className="counter">{this.props.game.counter}</div>
            ) : (
              ""
            )}
            <div>+time</div>
          </a>
        </div>
      </header>
    );
  }
}

function mapStateToProps(state) {
  return {
    game: state.game.entity
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ gameActions: gameActions }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/components/views/Header.js